import * as React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';

const CircularReverseIcon = ({ width = 39, height = 41 }) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox="0 0 39 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="19.5" fill="#B23E3E" />
    <path
      d="M19.7649 17C17.1149 17 14.7149 17.99 12.8649 19.6L9.26489 16V25H18.2649L14.6449 21.38C16.0349 20.22 17.8049 19.5 19.7649 19.5C23.3049 19.5 26.3149 21.81 27.3649 25L29.7349 24.22C28.3449 20.03 24.4149 17 19.7649 17Z"
      fill="white"
    />
  </SvgIcon>
);

CircularReverseIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default CircularReverseIcon;
